import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
      localStorage.getItem("AuthHandRememberMe") === "true" || sessionStorage.getItem("isLoggedHandsApp") ? (
        <Layout>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect to={{
          pathname: '/user/signin',
          state: { from: props.location }
          }}
        />
      )
  )} />
);

export default PrivateRoute;
